import { Injector, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '../../base.component';

@Component({
	selector: 'question-group',
	encapsulation: ViewEncapsulation.None,
	template: `
		<div class="question-group">
			<h3 *ngIf="isHaveVisibleControls()">{{ this.control.title }}</h3>
			<div>
				<control context="page" *ngFor="let control of control.controls" [control]="control"> </control>
			</div>
		</div>
	`,
	styleUrls: ['./question-group.component.scss'],
})
export class QuestionGroupComponent extends BaseComponent implements OnInit {
	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit() {}

	isHaveVisibleControls() {
		let result = false;
		this.control.controls.forEach((ctrl) => {
			if (ctrl.visible && !result) {
				result = true;
			}
		});
		return result;
	}
}
